import { Tag } from 'antd';
import { DocumentType } from 'types/document';
import type { IImportantDocumentFlagsProps } from './types';

export const ImportantDocumentFlags: React.FC<IImportantDocumentFlagsProps> = (props) => {
  const { documents, documentTypeMapping } = props;

  const documentEntries = Object.entries(documents);

  return documentEntries.map(([documentFlag, isAvailable]) =>
    isAvailable ? (
      <Tag key={documentFlag} color='success'>
        {DocumentType[documentTypeMapping[documentFlag]]}
      </Tag>
    ) : null,
  );
};
